import { createSlice } from '@reduxjs/toolkit';
import jwtDecode from 'jwt-decode';
import { Role } from '../../types/user.interface';
import { login, logout, register } from './auth.actions';
import { IAuthInitialState } from './auth.interface';

const initialState: IAuthInitialState = {
  isLoading: false,
  token: undefined,
  role: undefined,
  userId: undefined,
};

interface Token {
  role: keyof typeof Role;
  id: string;
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(login.pending, state => {
        state.isLoading = true;
      })
      .addCase(login.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.token = payload.token;
        const decoded = jwtDecode<Token>(payload.token);
        state.role = Role[decoded.role];
        state.userId = decoded.id;
      })
      .addCase(login.rejected, state => {
        state.isLoading = false;
        state.token = undefined;
        state.role = undefined;
        state.userId = undefined;
      })
      .addCase(register.pending, state => {
        state.isLoading = true;
      })
      .addCase(register.fulfilled, state => {
        state.isLoading = false;
      })
      .addCase(register.rejected, state => {
        state.isLoading = false;
      })
      .addCase(logout.fulfilled, state => {
        state.token = undefined;
        state.role = undefined;
        state.userId = undefined;
      });
  },
});
